import React from 'react'

const PageNotFound: React.FC = () => {
  const styles: React.CSSProperties = {
    position: 'relative',
    top: 300,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
  return <div style={styles}>Oops!! Requested Page not found</div>
}

export default PageNotFound
